import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin } from "lucide-react";

const Footer = () => {
  // Use current year directly to prevent hydration mismatch
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-toctoc-black text-gray-300">
      <div className="container max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div>
            <img 
              src="/lovable-uploads/24e0e29e-3e10-43db-8be9-1cc4bc18ab2f.png" 
              alt="TocToc Logo" 
              loading="lazy"
              width="114"
              height="64"
              className="h-8 mb-4 brightness-0 invert"
            />
            <p className="mb-4">
              O plano mais ágil para corretores que querem vender mais.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/toctoc.br?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="hover:text-toctoc-orange transition-colors" aria-label="Instagram">
                <Instagram size={20} strokeWidth={1.5} />
              </a>
              <a href="#" className="hover:text-toctoc-orange transition-colors" aria-label="Facebook">
                <Facebook size={20} strokeWidth={1.5} />
              </a>
              <a href="#" className="hover:text-toctoc-orange transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} strokeWidth={1.5} />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold text-white mb-4">Empresa</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="hover:text-toctoc-orange transition-colors">
                  Sobre nós
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-toctoc-orange transition-colors">
                  Blog
                </Link>
              </li>
              
              <li>
                <Link to="/contact" className="hover:text-toctoc-orange transition-colors">
                  Contato
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-white mb-4">Suporte</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/centraldeajuda" className="hover:text-toctoc-orange transition-colors">
                  Central de Ajuda
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="hover:text-toctoc-orange transition-colors">
                  Termos de Serviço
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-toctoc-orange transition-colors">
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-toctoc-orange transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p>&copy; {currentYear} Toc Toc. Todos os direitos reservados.</p>
          <p className="mt-4 md:mt-0">Feito com ❤️ para corretores de todo o Brasil</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
